import { Color, Spacing } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import { DrawerHeaderProps } from '@react-navigation/drawer';
import { useRoute } from '@react-navigation/native';
import React, { useContext, useEffect, useMemo } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';

import { signoutMenuItem } from '../../constants';
import { AppMenuContext } from '../../context';
import { MenuItem } from '../MenuItem';

const styles = StyleSheet.create({
  scrollContainer: {
    flex: 1,
    backgroundColor: Color['neutral.white'],
    padding: Utils.Token.ToInt(Spacing, 'inline.xxxs'),
    borderRightWidth: 1,
    borderRightColor: Color['neutral.lightest'],
  },
  scrollInner: {
    flex: 1,
    justifyContent: 'space-between',
  },
  itemsContainer: {
    gap: Utils.Token.ToInt(Spacing, 'inline.nano'),
  },
});

export const FixedSidebar: React.FC<DrawerHeaderProps> = ({ navigation }) => {
  const { items, setCurrentRoute } = useContext(AppMenuContext);
  const currentRoute = useRoute();
  const isDesktop = useBreakpointValue({
    base: false,
    md: true,
  });

  const menus = useMemo(
    () => items.map((item, index) => <MenuItem item={item} key={index} navigation={navigation} />),
    [items, navigation]
  );

  // NOTE: We need to use this since the navigation hooks are in different levels
  useEffect(() => {
    setCurrentRoute(currentRoute);
  }, [currentRoute, setCurrentRoute]);

  if (!isDesktop) {
    return;
  }

  return (
    <ScrollView
      showsHorizontalScrollIndicator={false}
      style={styles.scrollContainer}
      contentContainerStyle={styles.scrollInner}>
      <View style={styles.itemsContainer}>{menus}</View>
      <MenuItem item={signoutMenuItem} navigation={navigation} />
    </ScrollView>
  );
};
